export default __webpack_public_path__ + "static/media/status-color-2.a5792876.png";